type GenericCompose = Office.MessageCompose | Office.AppointmentCompose | null | undefined;

export class OfficeNotificationService {
    showInfoToast(mailboxItem: GenericCompose, key: string, message: string): void {
        if (!mailboxItem) {
            return;
        }
        mailboxItem.notificationMessages.replaceAsync(key, {
            type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
            icon: "unsure",
            message: this.truncateMessage(message),
            persistent: false,
        });
    }

    dismissInfoToast(mailboxItem: GenericCompose, key: string): void {
        if (!mailboxItem) {
            return;
        }
        mailboxItem.notificationMessages.removeAsync(key);
    }

    private truncateMessage(originalMessage: string): string {
        const trimmedMessage = originalMessage.trim();

        if (originalMessage.length > 150) {
            return `${trimmedMessage.substr(0, 140).trim()}...`;
        }
        return trimmedMessage;
    }
}
